export { default } from './SummaryTable'
